import Vue from 'vue';
import App from './App.vue';
import router from "./router";
import vuetify from './plugins/vuetify';
import { sync } from "vuex-router-sync";
import store from "./store/store";
import VueClipboard from 'vue-clipboard2';

Vue.config.productionTip = false;
sync(store, router);

Vue.use(VueClipboard);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
